import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { getProductCode, makeGetProductBrand, makeGetProductTechnicalCategories, } from '../../../../redux/product/selectors/ProductSelector';
import { filterProductCategoryEmptyFeatures } from '../../../../util/ProductUtil';
import { WarrantyLabel } from '../../warranty-label/WarrantyLabel';
/** Feature code for the warranty feature in the ASL product service. */
const WARRANTY_FEATURE_CODE = '6. - EU GARAN Years';
/**
 * Reads the warranty feature from the product's technical categories and renders
 * a WarrantyLabel if the feature is present with a valid numeric value.
 *
 * Applies filterProductCategoryEmptyFeatures before lookup, consistent with how
 * other feature category containers consume productTechnicalCategories.
 */
export const ProductDetailWarrantyLabel = ({ inPopover = false }) => {
    var _a;
    const categories = useSelector(makeGetProductTechnicalCategories());
    const brand = useSelector(makeGetProductBrand());
    const productCode = useSelector(getProductCode);
    const warrantyFeature = (categories === null || categories === void 0 ? void 0 : categories.flatMap(category => filterProductCategoryEmptyFeatures(category).features).filter(Boolean)).find(feature => feature.featureCode === WARRANTY_FEATURE_CODE);
    const warrantyYears = Number(warrantyFeature === null || warrantyFeature === void 0 ? void 0 : warrantyFeature.featureValue);
    if (!warrantyFeature || isNaN(warrantyYears) || warrantyYears <= 0) {
        return null;
    }
    return (_jsx(Box, { paddingBlock: "6", paddingInline: { base: inPopover ? '5' : '0', md: inPopover ? '6' : '0', xl: inPopover ? '8' : '0' }, children: _jsx(WarrantyLabel, { warrantyYears: warrantyYears, brand: (_a = brand === null || brand === void 0 ? void 0 : brand.description) !== null && _a !== void 0 ? _a : '', productCode: productCode !== null && productCode !== void 0 ? productCode : '' }) }));
};
